function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from "react";
import { Range, getTrackBackground } from "react-range";
import { withContext } from "../wr-context";
var InputRange = function(param) {
    var minValue = param.minValue, maxValue = param.maxValue, values = param.values, onChange = param.onChange, context = param.context, step = param.step;
    return /*#__PURE__*/ React.createElement(Range, {
        step: step,
        min: minValue,
        max: maxValue,
        values: values,
        onChange: onChange,
        allowOverlap: true,
        renderTrack: function(param) {
            var props = param.props, children = param.children;
            return /*#__PURE__*/ React.createElement("div", {
                onMouseDown: props.onMouseDown,
                onTouchStart: props.onTouchStart,
                style: _objectSpreadProps(_objectSpread({}, props.style), {
                    height: "36px",
                    display: "flex",
                    width: "100%"
                })
            }, /*#__PURE__*/ React.createElement("div", {
                ref: props.ref,
                style: {
                    height: "5px",
                    width: "100%",
                    borderRadius: "4px",
                    background: getTrackBackground({
                        values: values,
                        colors: [
                            context.theme.components.card.borderColor,
                            context.theme.palette.primary,
                            context.theme.components.card.borderColor, 
                        ],
                        min: minValue,
                        max: maxValue
                    }),
                    alignSelf: "center"
                }
            }, children));
        },
        renderThumb: function(param) {
            var props = param.props, isDragged = param.isDragged;
            return /*#__PURE__*/ React.createElement("div", _extends({}, props, {
                style: _objectSpreadProps(_objectSpread({}, props.style), {
                    height: "20px",
                    width: "20px",
                    backgroundColor: "#FFF",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid ".concat(isDragged ? context.theme.palette.primary : context.theme.components.card.borderColor)
                })
            }));
        }
    });
};
export default withContext(InputRange);
